import { Modal } from '@retailer-platform/shared-components'
import React, { type FunctionComponent } from 'react'
import { type ChildCollection } from 'domains/collections/types/collections.types'
import { type CollectionTypeEnum } from 'domains/collections/api'
import { CollectionsSelectCollectionsModalBody } from './components/body/CollectionsSelectCollectionsModalBody'

interface CollectionsSelectCollectionModalProps {
  title: string
  onSelect: (collection: ChildCollection) => void
  onClose: () => void
  collectionId: string
  retailerId?: string
  collectionType: CollectionTypeEnum
}

export const CollectionsSelectCollectionModal: FunctionComponent<
  CollectionsSelectCollectionModalProps
> = ({ title, onSelect, onClose, collectionId, retailerId, collectionType }) => (
  <Modal
    headerContent={title}
    bodyContent={
      <CollectionsSelectCollectionsModalBody
        onSelect={onSelect}
        collectionId={collectionId}
        retailerId={retailerId}
        collectionType={collectionType}
      />
    }
    isOpen={true}
    onRequestClose={onClose}
    maxHeight="100%"
    maxWidth={800}
  />
)
